import axios from 'axios'
import store from 'store'
import { AUTH_TOKEN_KEY, ROLES } from '../../constants'
import { authUrl, baseUrl, serverUrl } from 'Config'
import JWT from 'jwt-client'
import swal from 'sweetalert'

import CacheService from '../Cache/CacheService';
import TaxonomyService from '../Cache/micro-services/taxonomy';

const SESSION = 'CorlyticsSession'

class AuthService {

	constructor() {
		this.message = '';
		this.session = store.get(SESSION);
		this.cacheServiceLoaded = false;
		this.userFirstload = true;
		this.userChecked = false; // Boolean if user was checked as logged in or not
		this.userCheckedTimeout = null;
		this.checkDebounce = 50;//30 * 60 * 1000; // thirty minutes
		this.loginResponseData = null;
	}

	initService() {
		const _this = this;
		if (this.isLoggedIn() && !this.cacheServiceLoaded) {
			this.cacheServiceLoaded = true;
			CacheService.init();
		}

		if (this.session == null) {
			// window.location.href = '/login'
			//window.location.reload()
		}

		// axios.interceptors.request.use((config) => {
		// 	const date = new Date();
		// 	const paramExists = config.url.indexOf('?') > -1;
		// 	config.url += (paramExists ? '&' : '?') + 'nd=' + date.getTime();
		// 	return config;
		// });

		axios.interceptors.response.use(function (response) {
			if ('modelname' in response.headers) {
				TaxonomyService.checkTaxonomy(response.headers.modelname, response.headers.updatedat)
			}
			return response;
		}, function (error) {

			if (error && error.response && error.response.status === 401 && _this.isLoggedIn()) {

				// New code with no popup messages
				_this.clear()
				_this.message = error.response.data.message;
				_this.session = null;
				if (window.location.pathname === '/login') {
					window.location.href = '/login';
				}
				else {
					window.location.href = '/login?url=' + window.location.pathname + window.location.search;
				}

				// Old version of login popup with sweet alert in use
				// swal({
				// 	title: error.response.data.error,
				// 	text: error.response.data.message,
				// 	icon: "error",
				// 	button: {
				// 		text: "Return to Login"
				// 	}
				// }).then(() => {
				// 	_this.clear()
				// 	_this.message = error.response.data.message;
				// 	_this.session = null;
				// 	if (window.location.pathname === '/login') {
				// 		window.location.href = '/login';
				// 	}
				// 	else {
				// 		window.location.href = '/login?url=' + window.location.pathname + window.location.search;
				// 	}

				// })
			}
			return Promise.reject(error)
		})
	}

	tokenLogin(token) {
		return new Promise((resolve, reject) => {
			this.clear();
			axios({
				method: 'POST',
				url: baseUrl + '/auth/token_login',
				data: { token }
			})
				.then(response => {
					this.loginSuccessResponse(response.data);
					resolve();
				})
				.catch(error => {
					this.loginErrorResponse(error);
					reject();
				});

		})
	}

	login(u, p) {
		this.clear();
		return axios({
			method: 'POST',
			url: authUrl,
			data: { username: u, password: p }
		})
			.then(response => {
				this.loginResponseData = response.data;

				// Two lines just for test - to remove
				// this.loginResponseData.force_change_password = true;
				// this.loginResponseData.policies_accepted = false;

				if (this.loginResponseData.policies_accepted && !this.loginResponseData.force_change_password) {
					return this.loginSuccessResponse();
				}
				else {
					return {
						forceScreen: true,
						policies: !this.loginResponseData.policies_accepted,
						password: this.loginResponseData.force_change_password
					}
				}
			})
			.catch(error => this.loginErrorResponse(error));
	}

	loginSuccessResponse() {
		const data = this.loginResponseData;
		this.userChecked = true;
		this.session = data;
		store.set('modelName', data.model_name)
		store.set(SESSION, this.session)
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.session.auth_token
		console.log("Welcome " + this.getUsername())
		console.log("Application Version " + this.session.version);

		if (!this.cacheServiceLoaded) {
			this.cacheServiceLoaded = true;
			CacheService.init();
		}
		return data;
	}

	loginErrorResponse(error) {
		this.clear();
		this.message = error.response.data.message;
		this.username = 'Not Logged In';
		axios.defaults.headers.common['Authorization'] = '';
		return error;
	}

	checkAccess(role) {
		if (!this.session) {
			if (store.get(SESSION)) {
				this.session = store.get(SESSION);
			} else
				return window.location.href = '/login';
		}
		if (!this.session.roles) return null;
		return this.session.roles.includes(ROLES[role]);
	}

	getToken() {
		//return this.token
		if (!this.session) this.session = store.get(SESSION)
		return typeof this.session !== 'undefined' ? this.session.auth_token : null;
	}

	getUsername() {
		if (!this.session) this.session = store.get(SESSION)
		const username = JWT.read(this.session.auth_token).claim.username
		return username || '';
	}

	getUserSelector() {
		// Intended for use in a SELECT list of users
		// Returns {"label":<username>,"value":<User Id>}
		if (!this.session) this.session = store.get(SESSION)
		const username = JWT.read(this.session.auth_token).claim.username
		const sub = JWT.read(this.session.auth_token).claim.sub
		return { "label": username || '', "value": sub || '' };
	}

	getUsersClient() {
		if (!this.session) this.session = store.get(SESSION);

		if (this.session.client_id) {
			return this.session.client_id;
		}
		return '';
	}

	getClientName() {
		if (!this.session) this.session = store.get(SESSION);

		if (this.session.client_name) {
			return this.session.client_name;
		}
		return null;
	}

	getMessage() {
		return this.message
	}

	getMenuItems() {
		if (!this.session) this.session = store.get(SESSION);
		if (this.session) return this.session.menu_items
		return [];
	}

	isAdmin() {
		//return (this.admin)
		if (!this.session) this.session = store.get(SESSION);

		if (!this.session.roles) return null;
		return this.session.roles.includes('ADMIN');
	}

	isLoggedIn() {
		return (this.session != null)
	}

	clear() {
		this.message = '';
		this.session = null;
		store.clearAll();
	}

	postLogout() {
		this.setUserChecked(false);
		this.clear();
		window.location.href = '/login';
	}

	logout() {
		axios({
			method: 'POST',
			url: baseUrl + '/auth/logout',
			data: {},
			headers: { 'Authorization': 'Bearer ' + this.getToken() }
		})
			.then(resp => this.postLogout())
			.catch(e => this.postLogout());
	}

	checkIfUserIsLoggedIn() {
		return axios({
			method: 'GET',
			url: serverUrl + '/user-logged-in/',
			headers: { 'Authorization': 'Bearer ' + this.getToken() }
		})
	}

	setUserChecked(status) {
		this.userChecked = status;
	}

	getUserChecked() {
		//if (this.userCheckedTimeout) clearTimeout(this.userCheckedTimeout);

		return this.userChecked;
	}

	setUserRoles(roles) {
		const currentSession = store.get(SESSION);

		if (this.session) this.session.roles = roles;
		if (currentSession) {
			store.set(SESSION, { ...currentSession, roles });
		}
	}

	getPolicies() {
		return axios({
			method: 'GET',
			url: serverUrl + '/policies/',
			headers: { 'Authorization': 'Bearer ' + this.loginResponseData.auth_token }
		});
	}

	acceptPolicies(data) {
		return axios({
			method: 'PUT',
			data: data,
			url: serverUrl + '/accept-policies/',
			headers: { 'Authorization': 'Bearer ' + this.loginResponseData.auth_token }
		});
	}

	saveNewPassword(data) {
		return axios({
			method: 'PUT',
			data: data,
			url: serverUrl + '/change-pwd-first-login/',
			headers: { 'Authorization': 'Bearer ' + this.loginResponseData.auth_token }
		});
	}

}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/AuthService/AuthService.js